import { FC } from 'react';

import { ListId } from 'modules/domains/list';
import {
  createSelectionContext,
  SelectionContextState,
  useSelectionContext,
} from 'utils/contexts/selection';
import { useListsContext } from './lists';

export type ListSelectionContext = SelectionContextState<ListId>;

const [ListSelectionContext, useListSelectionContext] = createSelectionContext<ListId>();

export { ListSelectionContext as SelectionContext, useListSelectionContext as useSelectionContext };

export const SelectionContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { folderId, listFolders, lists } = useListsContext();
  const context = useSelectionContext<ListId>({
    folderId,
    folders: listFolders,
    contentItems: lists,
  });

  return <ListSelectionContext.Provider value={context}>{children}</ListSelectionContext.Provider>;
};
